import DonorPaymentPreview from "./DonorPaymentPreview"

export default function DonorPaymentPreviewPage() {
  return (<>
    <DonorPaymentPreview></DonorPaymentPreview>
  </>);
}